import { StatusCodes } from "http-status-codes";
import { loadServerTranslations } from "../../i18n/messages";
import BlogSlug from "pages/[lang]/blog/[slug]";
import { Locales } from "i18n/country";
import { resolveBlogSlugPage } from "domain/BlogAndNews/utils/resolveBlogSlugPage";

export default BlogSlug;

export const getServerSideProps = async ({ res, params: { slug = null } = {} }) => {
  const locale = Locales.USA;
  const page = await resolveBlogSlugPage(locale, slug);

  if (page.kind === "notFound") {
    res.statusCode = StatusCodes.NOT_FOUND;
  }

  return {
    props: {
      ...page,
      locale,
      messages: await loadServerTranslations(locale, ["common", "page-index", "page-error", "page-blog"]),
    },
  };
};
